import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { DataSource } from '@angular/cdk/collections';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/debounceTime';
import { OpcionModel } from '../Global/Opcion.model';
import { DistribucionRendimientosModel } from './DistribucionRendimientos.model';
import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import { MatSnackBar } from '@angular/material';


@Component({
    selector: 'DistribucionRendimientos',
	templateUrl: './DistribucionRendimientos.component.html',
	styleUrls: ['../../../../styles.css']
})

/**
* @author Michael
* @since  22/04/2019
**/
export class DistribucionRendimientos {

	public form: FormGroup;
	public formErrors: any;
    public ocultar: boolean = false;
    public fechaDesde:Date;
    public fechaHasta:Date;
    public fechaDistribuirHasta:Date;
	public valorRendimientos: string;
    public mostrarDiv=false;
	
	public guardando: boolean = true;

	myControl = new FormControl();
	filteredOptions: Observable<OpcionModel[]>;
	

	public btnConsultar: boolean;

    public ocultarSnackBar: boolean = false;
	public mensaje: string = "";

	constructor(private formBuilder: FormBuilder, private _serviciosGenerales: ServiciosGenerales, public snackBar: MatSnackBar,
		private _route: ActivatedRoute, private _router: Router, public dialog: MatDialog) {

            this.formErrors = {

                fechaDesde: {},
                fechaHasta: {},
                fechaDistribuirHasta:{},
                valorRendimientos: {}
            };

		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnConsultar = _serviciosGenerales.seguridad.isConsultar();
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
        this.snackBar.dismiss();
	}


    ngOnInit() {
        this._serviciosGenerales.get('fechaUltimaDistribucion', {}).subscribe(
            result => {

                for (var x of result) {
                    this.fechaDesde = new Date(x.fecha);
                }
            },
            error => {
                var errorMensaje = <any>error;
                console.log('Error al enviar la peticion ', errorMensaje);

            });
        this.inicializarFormulario();
    }

	onFormValuesChanged() {
		for (const field in this.formErrors) {
			if (!this.formErrors.hasOwnProperty(field)) {
				continue;
			}

			// Clear previous errors
			this.formErrors[field] = {};

			// Get the control
			const control = this.form.get(field);

			if (control && control.dirty && !control.valid) {
				this.formErrors[field] = control.errors;
			}
		}
	}

	openSnackBar(message: string, action: string) {
		this.snackBar.open(message, action, {
			duration: 20000
		});
	}

    openSnackBarEspecial(message: string, action: string) {
		let snackBarRef =  this.snackBar.open(message, action);

		snackBarRef.onAction().subscribe(() => {

			this.ocultarSnackBar = false;
			this.mensaje = "";
		});
		
		let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;		
		
		if (shand.length != 0) {
			    for (let i=0;i<shand.length;i++){
				shand[i].style.backgroundColor = "rgb(255 204 214)";
				}
			}
	}


    inicializarFormulario() {
	    
		this.form = this.formBuilder.group({
            fechaDesde: ['', Validators.required],
            fechaHasta: ['', Validators.required],
			valorRendimientos: [0, Validators.required],
            fechaDistribuirHasta:[]
		});

		this.form.valueChanges.subscribe(() => {
			this.onFormValuesChanged();
		});
    }


    distribuirRendimientos(){

        this.guardando = false;
        //console.log("fecha desde:",new Date(this.fechaDesde).toISOString().substr(0, 10)," fecha hasta:",new Date(this.fechaHasta).toISOString().substr(0, 10)," Valor:",this.valorRendimientos)

        if (this,this.fechaHasta<this.fechaDesde){
            this.openSnackBarEspecial('El valor de la Fecha Hasta no puede menor al de la Fecha Desde.', 'X');
            this.guardando = true;
			return;
        }
        
        if(parseFloat(this.valorRendimientos)<0 && this.fechaDistribuirHasta == undefined) {
            this.openSnackBarEspecial('Se debe ingresar un valor en el campo Distribuir hasta.', 'X');
            this.guardando = true;
			return;
        }
        let parametros;

        if (this.fechaDistribuirHasta == undefined ){
            parametros = { 
                FECHA_DESDE : new Date(this.fechaDesde).toISOString().substr(0, 10),
                FECHA_HASTA : new Date(this.fechaHasta).toISOString().substr(0, 10),
                FECHA_DISTRIBUIR :new Date("01/01/1900",).toISOString().substr(0, 10),
                VALOR_RENDIMIENTOS : this.valorRendimientos.toString(),
                VUSUARIO: this._serviciosGenerales.seguridad.getInfoSesion().usuario
             };    
         }
        else{
            parametros = { 
                FECHA_DESDE : new Date(this.fechaDesde).toISOString().substr(0, 10),
                FECHA_HASTA : new Date(this.fechaHasta).toISOString().substr(0, 10),
                FECHA_DISTRIBUIR : new Date(this.fechaDistribuirHasta).toISOString().substr(0, 10),
                VALOR_RENDIMIENTOS : this.valorRendimientos.toString(),
                VUSUARIO: this._serviciosGenerales.seguridad.getInfoSesion().usuario
             };
         }
        this._serviciosGenerales.get('procedure/PRC_DISTRIBUCION_RENDIMIENTOS', parametros).subscribe(
            result => {
            

                if (result.error == true || result.mensaje.toUpperCase().indexOf('OK') == -1) {
                    this.openSnackBarEspecial(result.mensaje, "X");
                    this.guardando = true;
                    return;
                } else {
                    this.form.reset();
                    this.form.clearAsyncValidators();
                    this.form.clearValidators();
                    this.inicializarFormulario();
                    this.openSnackBar('Distribución Rendimientos correctamente: '+result.mensaje.replace('OK',''), "X");
                }
                this.guardando = true;
            }, error => {
                var errorMensaje = <any>error;
                console.log('Error al enviar la peticion ', errorMensaje);
                this.openSnackBarEspecial("No se logró obtener la respuesta del servidor, por favor verificar si se efectuó este proceso.", "X");
                this.guardando = true;
            })
    }

    bloquearBoton(){
		var count = 1;
		this.distribuirRendimientos();
	}

	mostrar(){
        if(parseFloat(this.valorRendimientos)<0){
            this.mostrarDiv = true;
        }
        else {
            this.mostrarDiv = false;
            this.fechaDistribuirHasta = undefined;
        }
	}

}



// WEBPACK FOOTER //
// D:/REPO/FacturacionWeb/src/app/main/content/DistribucionRendimientos/DistribucionRendimientos.component.ts